import React, { Component } from "react";
import { Row, Col, Menu } from "antd";
import Site from "./site";
import RecordChart from "./recordChart";
import Verification from "./verification";
const MenuItem = Menu.Item;

class Staffing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selMenuKey: "1",
      select_team: {},
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 设置值
   * @param data
   * @param cb
   */
  setData = (data, cb) => {
    if (this._isMounted) {
      this.setState(data, () => {
        if (cb) cb();
      });
    }
  };

  /**
   * 队伍选择
   * @param select_team
   * @param load_index
   */
  teamSelected = (select_team, load_index) => {
    this.setData({ select_team, load_index });
  };

  /**
   * Tab按钮点击事件
   **/
  handleTabBtnClick = (e) => {
    const key = e.key,
      { selMenuKey } = this.state;
    if (selMenuKey !== key) {
      this.setData({ selMenuKey: key });
    }
  };

  render() {
    const { selMenuKey, select_team } = this.state,
      team_id = select_team.team_id || "";
    let content_node = null,
      itemNode = null;
    switch (selMenuKey) {
      case "3":
        content_node = <Site />;
        break;
      case "1":
        content_node = <RecordChart />;
        break;
      case "2":
        content_node = <Verification />;
        break;
    }
    itemNode = (
      <Row className="content">
        <Col span={23} offset={1} className="team-table">
          {content_node}
        </Col>
      </Row>
    );

    return (
      <div className="rank-staffing team-editor">
        <Row className="top-title">
          <Col span={12} style={{display:'flex',alignItems:'center'}}>
            {selMenuKey == 1
              ? "兑换记录"
              : selMenuKey == 2
              ? "核销人员"
              : selMenuKey == 3
              ? "核销地址"
              : " "}
              {selMenuKey ==1 && <span style={{color:'red',fontSize:14,display:'inline-block',marginLeft:10}}>兑换流程: 1、队员在线申请兑换商品; 2、队员到指定核销点出示核销码进行核销; 3、核销员派发爱心商品</span>}
              {selMenuKey ==2 && <span style={{color:'red',fontSize:14,display:'inline-block',marginLeft:10}}>所有爱心商品都需要核销员进行核销后再派发</span>}
          </Col>
          <Col span={12} className="tab-btns">
            <Menu
              onSelect={this.handleTabBtnClick}
              selectedKeys={[selMenuKey]}
              mode="horizontal"
            >
              <MenuItem key="3" className="no-select">
                <span>核销地址</span>
              </MenuItem>
              <MenuItem key="2" className="no-select">
                <span>核销人员</span>
              </MenuItem>
              <MenuItem key="1" className="no-select">
                <span>兑换记录</span>
              </MenuItem>
            </Menu>
          </Col>
        </Row>
        {itemNode}
      </div>
    );
  }
}

export default Staffing;



// WEBPACK FOOTER //
// ./src/routes/grade/commodity.jsx